/**
 * Format thời gian tương đối kiểu Zalo: "vừa xong", "5 phút", "22 giờ",
 * "3 ngày", "2 tuần", "10/04". Sau 30 ngày → đổi sang dd/MM.
 */
export const formatRelativeTime = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "—";

  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const sec = Math.floor(diffMs / 1000);

  if (sec < 60) return "vừa xong";
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} phút`;
  const hour = Math.floor(min / 60);
  if (hour < 24) return `${hour} giờ`;
  const day = Math.floor(hour / 24);
  if (day < 30) return `${day} ngày`;

  // > 30 ngày → dd/MM
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}`;
};

/**
 * Format dạng dd/MM (luôn) — dùng cho cards "Lời mời đã nhận".
 */
export const formatShortDate = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "—";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}`;
};
